
import { toast } from 'sonner';

// Using Tesseract.js for OCR processing
const API_URL = "https://api.ocr.space/parse/image";
const API_KEY = "K85776150388957"; // Free OCR API key for demo purposes

export interface OCRResponse {
  success: boolean;
  text: string;
  error?: string;
}

export async function scanDocument(imageFile: File, language = 'eng'): Promise<OCRResponse> {
  try {
    // Check file size (limit to 5MB)
    if (imageFile.size > 5 * 1024 * 1024) {
      return {
        success: false,
        text: '',
        error: 'File size exceeds 5MB limit'
      };
    }
    
    // Create form data for the API request
    const formData = new FormData();
    formData.append('file', imageFile);
    formData.append('language', language === 'ur' ? 'urd' : 'eng'); // Use Urdu language code for Urdu
    formData.append('apikey', API_KEY);
    formData.append('isOverlayRequired', 'false');
    formData.append('detectOrientation', 'true');
    formData.append('scale', 'true');
    
    // Make the API request
    const response = await fetch(API_URL, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`OCR API error: ${response.status}`);
    }

    const data = await response.json();
    
    if (!data.ParsedResults || data.ParsedResults.length === 0) {
      throw new Error('No text found in the image');
    }

    // Extract the parsed text from the response
    const extractedText = data.ParsedResults[0].ParsedText || '';
    
    if (!extractedText) {
      return {
        success: true,
        text: 'No text was detected in the image.',
      };
    }

    return {
      success: true,
      text: extractedText
    };
  } catch (error) {
    console.error('OCR processing error:', error);
    return {
      success: false,
      text: '',
      error: error instanceof Error ? error.message : 'Unknown OCR processing error'
    };
  }
}
